import React, { useCallback } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { CompanyQueryData } from '@area-restrita/api-client/model/companyQueryData';
import { getGetCompaniesQueryOptions } from '@area-restrita/api-client/endpoints/companies/companies.gen';

import Dialog from '@/components/template/Dialog';
import { Button } from '@/components/ui/button';
import PageContainer from '@/components/layout/PageContainer';
import DataGrid from '@/components/DataGrid';
import DataTableToolbar from '@/components/DataTable/DataTableToolbar';
import { useQueryTable } from '@/hooks/useQueryTable';
import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';

import AddCompany from '../../components/AddCompany';
import { columns } from './columns';

const Companies: React.FC = () => {
  const { checkAuthorization } = useAuthSessionStore();
  const navigate = useNavigate({ from: '/companies/' });

  // const { data } = useGetCompanies({ page: 1, limit: 9999 });

  // const cities = useMemo(
  //   () =>
  //     Array.from(new Set(data?.data.map(({ city }) => city))).map((city) => ({
  //       label: city,
  //       value: city,
  //     })),
  //   [data],
  // );

  // const states = useMemo(
  //   () =>
  //     Array.from(new Set(data?.data.map(({ state }) => state))).map(
  //       (state) => ({
  //         label: state,
  //         value: state,
  //       }),
  //     ),
  //   [data],
  // );

  const handleRowClick = useCallback(
    ({ id }: CompanyQueryData) => {
      navigate({
        to: '/companies/$companyId/users',
        params: { companyId: id.toString() },
      });
    },
    [navigate],
  );

  const canCreate = checkAuthorization(({ can }) => can('create', 'companies'));
  const canViewDetails = checkAuthorization(({ can }) =>
    can('viewDetails', 'companies'),
  );

  const {
    query: { isLoading },
    table,
  } = useQueryTable({
    columns,
    getQueryOptions: getGetCompaniesQueryOptions,
  });

  return (
    <PageContainer title="Empresas">
      <DataGrid
        variant="card"
        table={table}
        isLoading={isLoading}
        toolbar={
          <DataTableToolbar
            table={table}
            searchPlaceholder="Buscar empresa..."
            searchColumnId="search"
          />
        }
        actions={
          canCreate && (
            <Dialog
              title="Adicionar Empresa"
              description="Adicione uma nova empresa à lista"
              trigger={<Button size="sm">Adicionar Empresa</Button>}
            >
              <AddCompany />
            </Dialog>
          )
        }
        onRowClick={canViewDetails ? handleRowClick : undefined}
      />
    </PageContainer>
  );
};

export default Companies;
